import React, { useEffect, useState} from "react";
import { toInt, StyledTableCell, format_date_only, getTimeInIST, HtmlTooltip, openLink, formatNumber, format_display_date, format_display_DDMMYYYY} from '../../Utils';
import moment from 'moment';
import {UserService} from '../../Services/UserService';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid, Typography, ListItemText, TableRow, TablePagination, Table, TableBody, IconButton } from "@material-ui/core";
import queryString from 'query-string';
import { STATES } from "../../Constants";
import SingleDate from "../../components/SingleDate";
import { DeliveryService } from "../../Services/DeliveryService";
import { RowCountOptions } from "../../Config";
import ItemSelection from "../../components/ItemSelection";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import GetAppIcon from '@material-ui/icons/GetApp';
import clsx from "clsx";
import XLSX from 'xlsx';

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    tablecellAction: {
        fontSize: '10pt',
        padding: 2,
        color: 'blue',
        cursor: 'pointer',
        textAlign: 'left'
    },
}));

export default function StateWiseDeliveryReport(props){
    const classes = useStyles();
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(undefined);
    const [generate, setGenerate] = useState(false);
    const [startdate, setStartdate] = useState(moment());
    const [enddate, setEnddate] = useState(moment());
    // const [filter, setFilter] = React.useState('');
    const order = 'asc';
    const orderBy = 'pledge_no';
    const [currentRows, setCurrentRows] = React.useState([]);
    const columns = [
        { id: 'schedule_date', numeric: false, disablePadding: false, label: 'Scheduled Date', sortable: false  },
        { id: 'store_name', numeric: false, disablePadding: false, label: 'Store', sortable: false  },
        { id: 'invoice_no', numeric: false, disablePadding: false, label: 'Invoice No', sortable: false  },
        { id: 'credit_note_no', numeric: false, disablePadding: false, label: 'Credit Note No', sortable: false  },
        { id: 'grn', numeric: false, disablePadding: false, label: 'GRN', sortable: false  },
        { id: 'po_no', numeric: false, disablePadding: false, label: 'PO No', sortable: false  },
        { id: 'total_amount', numeric: false, disablePadding: false, label: 'Total Billed Amount', sortable: false  },
        { id: 'total_return_amount', numeric: false, disablePadding: false, label: 'Total Returned Amount', sortable: false  },
        { id: 'delivered_count', numeric: false, disablePadding: false, label: 'Delivered Count', sortable: false  },
        { id: 'returned_count', numeric: false, disablePadding: false, label: 'Returned Count', sortable: false  },
        { id: 'route_name', numeric: false, disablePadding: false, label: 'Route', sortable: false  },
        { id: 'delivery_agent_name', numeric: false, disablePadding: false, label: 'Agent', sortable: false  },
        { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false  },
    ];

    //Pagination
    const [totalItems, setTotalItems] = React.useState(0);
    const [numItemsPerPage, setNumItemsPerPage] = React.useState(RowCountOptions[0]);
    const [currentPageNumber, setCurrentPageNumber] = React.useState(0);
    const [fetchPage, setFetchPage] = React.useState(false);

    const handleChangeRowsPerPage = event => {
        setNumItemsPerPage(event.target.value);
        setCurrentPageNumber(0);
        setFetchPage(true);
    }

    const handleChangePage = (event, page) => {
        if(currentPageNumber > page){
            fetchRow(currentPageNumber - 1);
        } else {
            fetchRow(currentPageNumber + 1);
        }
    };

    const fetchRow = (newCurrentPage) => {
        setCurrentPageNumber(newCurrentPage);
        setFetchPage(true);
    }

    useEffect(() => {
        UserService.getAvailableStates()
        .then(data => {
            let states = [];
            data.forEach(d => {
                let state = STATES.find(s => s.code === d);
                states.push({code: d, name: state.name});
            });
            setStates(states);
            if(props.location.search){
                let qString = queryString.parse(props.location.search);
                if(qString.state){
                    let state = STATES.find(s => s.code === qString.state);
                    setSelectedState(state);
                    if(qString.startdate){
                        setStartdate(moment(qString.startdate));
                    }
                    if(qString.enddate){
                        setEnddate(moment(qString.enddate));
                    }
                    setGenerate(true);
                }
            }
        })
        return () => {
            
        }
    }, []);

    React.useEffect(() => {
        if(generate && selectedState){
            setCurrentRows([]);
            props.isLoading(true);
            setCurrentPageNumber(0);
            setTotalItems(0);
            props.showProgressDialog('Generating Report...');
            DeliveryService.getStateDeliveryCount(selectedState.code, startdate, enddate)
            .then(data => {
                console.log(data);
                setTotalItems(toInt(data.count));
                setFetchPage(true);
                if(toInt(data.count) === 0){
                    setCurrentRows([]);
                }
                props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                props.isLoading(false);
                props.closeProgressDialog();
            });
        }
        setGenerate(false);
    }, [generate]);

    React.useEffect(() => {
        let rows = [];
        if(fetchPage) {
            props.isLoading(true);
            DeliveryService.getStateDelivery(selectedState.code, startdate, enddate, currentPageNumber * numItemsPerPage, numItemsPerPage)
            .then((data) => {
                // console.log(data);
                if(data){
                    data.forEach((element, index) => {
                        rows.push(
                            <TableRow 
                                key={index} 
                                hover>
                                <StyledTableCell scope="row" align="center" padding='none' className={classes.cellStyle}>
                                    {getTimeInIST(element.schedule_date).format(format_date_only)}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="left" padding='none' className={classes.cellStyle} style={{maxWidth: '20vw'}}>
                                    <HtmlTooltip 
                                        arrow 
                                        title={
                                            <>
                                                <Typography variant="caption">
                                                    Store: {element.store_name}
                                                    <br/>
                                                    <hr style={{margin: 0}}/>
                                                    Address: {element.flat}
                                                </Typography>
                                            </>
                                        }>
                                        <ListItemText
                                            primary={element.store_name || '-'}
                                            secondary={element.flat ? element.flat.length > 30 ? `${element.flat.substr(0, 30)}...` : element.flat : ''}/>
                                    </HtmlTooltip>
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' className={element.invoice_no ? clsx(classes.cellStyle, classes.tablecellAction) : classes.cellStyle} onClick={() => element.invoice_url ? openLink(element.invoice_url) : undefined } style={{paddingRight: 8}}>
                                    <>{element.invoice_no ? element.invoice_no : "-"}</>
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' className={element.credit_note_no ? clsx(classes.cellStyle, classes.tablecellAction) : classes.cellStyle} onClick={() => element.credit_note_url ? openLink(element.credit_note_url) : undefined }>
                                    {element.credit_note_no ? element.credit_note_no : "-"}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' className={classes.cellStyle}>
                                    {element.grn || '-'}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none' className={classes.cellStyle}>
                                    {element.po_no || '-'}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    <HtmlTooltip arrow title={`Expected: ${formatNumber(element.expected_amount)}`}>
                                        <div>{formatNumber(element.total_amount || 0)}</div>
                                    </HtmlTooltip>
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    <>{formatNumber(element.total_return_amount || 0)}</>
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    <HtmlTooltip 
                                        arrow 
                                        title={
                                            <>
                                                <Typography variant="caption">
                                                    Scheduled Qty: {element.product_qty}
                                                    <br/>
                                                    <hr style={{margin: 0}}/>
                                                    {`Delivered Qty : ${element.delivered_count || 0}`}
                                                </Typography>
                                            </>
                                        }>
                                        <div>{`${(element.delivered_count || 0)} / ${(element.product_qty || 0)}`}</div>
                                    </HtmlTooltip>
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    {element.returned_count || 0}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    {element.route_name || ''}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    {element.delivery_agent_name || '-'}
                                </StyledTableCell>
                                <StyledTableCell scope="row" align="center" padding='none'  className={classes.cellStyle}>
                                    {element.delivery_date ? getTimeInIST(element.delivery_date).format(format_display_date) : '-'}
                                </StyledTableCell>                          
                            </TableRow>
                        );
                    });
                }
                setCurrentRows(rows);
                props.isLoading(false);
                props.closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                props.isLoading(false);
                props.closeProgressDialog();
            });
        }
        setFetchPage(false);
    }, [fetchPage]);

    const sortBy = (event, property) => {
        // let o = 'desc';
        // if (orderBy === property && order === 'desc') {
        //     o = 'asc';
        // }
        // setOrder(o);
        // setOrderBy(property);
        // setGenerate(true);
    }

    const exportReport = e => {
        if(totalItems > 0){
            props.showProgressDialog('Exporting....');
            DeliveryService.getStateDelivery(selectedState.code, startdate, enddate, 0, totalItems)
            .then((data) => {
                // console.log(data);
                if(data){
                    let rows = [];
                    let filename = `${selectedState.name} - ${startdate.format(format_display_DDMMYYYY)} - ${enddate.format(format_display_DDMMYYYY)}`;
                    rows.push(['State' , selectedState.name])
                    rows.push(['Duration' , startdate.format(format_display_DDMMYYYY), enddate.format(format_display_DDMMYYYY)])
                    rows.push(['Scheduled Date', 'Store', 'Address', 'Invoice No', 'Credit Note No', 'GRN', 'PO No', 
                                'Total Billed Amount', 'Total Returned Amount', 'Expected Count', 'Delivered Count', 'Returned Count', 
                                'Route', 'Agent', 'Delivery Date']);
                    data.forEach((element, index) => {
                        rows.push([getTimeInIST(element.schedule_date).format(format_date_only), element.store_name, element.flat, 
                                    element.invoice_no, element.credit_note_no, element.grn, element.po_no, element.total_amount,
                                    element.total_return_amount, element.product_qty, element.delivered_count, element.returned_count, 
                                    element.route_name, element.delivery_agent_name, element.delivery_date ? getTimeInIST(element.delivery_date).format(format_display_date) : '']);
                    });
                    const wb = XLSX.utils.book_new();
                    const wsAll = XLSX.utils.aoa_to_sheet(rows);
                    XLSX.utils.book_append_sheet(wb, wsAll, 'Report');
                    XLSX.writeFile(wb, filename + ".xlsx");
                }
                props.closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                props.showSnackBar('Error while Exporting. Please try again', 'error', 2000);
                props.closeProgressDialog();
            })
        } else {
            props.showSnackBar('No data to Export', 'info', 2000);
        }
    }



    return (
         <div className="Home agent_report" style={{marginTop: 32}}>
            <Paper style={{paddingTop: 8, paddingBottom: 8}}>
                <Grid container spacing={1} alignItems="center" style={{paddingLeft: 8, paddingRight: 8}}>
                    <Grid item xs={12} lg={2}>
                        <ItemSelection 
                            required 
                            label='State' 
                            value={selectedState || null} 
                            optionLabel='name' 
                            options={states} 
                            selected={(state) => setSelectedState(state)}/>
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <SingleDate 
                            label="From"
                            margin="dense"
                            date={startdate}
                            maxDate={moment()}
                            setDate={(date) => {
                                setStartdate(date);
                            }}/>
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <SingleDate 
                            label="To"
                            margin="dense"
                            date={enddate}
                            setDate={(date) => {
                                setEnddate(date)
                            }}/>
                    </Grid>
                    <Grid item>
                        <Button 
                            variant="contained" 
                            color="primary"
                            style={{marginRight: 8, marginTop: 8}} 
                            onClick={(e) => setGenerate(true)}>
                            Generate
                        </Button>
                    </Grid>
                    <Grid item>
                        <IconButton
                            style={{marginRight: 8, marginTop: 8}} 
                            onClick={(e) => exportReport(true)}>
                            <GetAppIcon />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <div style={{minHeight: 100, overflowY: 'auto', display: 'block'}}>
                            <Table className={classes.table} stickyHeader>
                                <EnhancedTableHead
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={sortBy}
                                    rows={columns} />
                                <TableBody>
                                    {currentRows}
                                </TableBody>
                            </Table>
                        </div>
                        {
                            totalItems === 0 && 
                                <Typography color="error" variant="subtitle2">No Schedules</Typography>
                        }
                        <TablePagination
                            rowsPerPageOptions={RowCountOptions}
                            component="div"
                            count={totalItems}
                            rowsPerPage={numItemsPerPage}
                            page={currentPageNumber}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            classes={{ selectRoot : classes.selectRoot}}/>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );

}